import React, { createContext, useState } from "react";
export const filtrationcontext = createContext();

export default function Filtercontext({ children }) {
	let [checked, setChecked] = useState([]);
	let [parentCheck, setParentCheck] = useState([]);
	let [childCheck, setChildCheck] = useState([]);
	let [subchildCheck, setSubChildCheck] = useState([]);
	const [filter, setFilter] = useState(false);
	const [isFilterTriggered, setIsFilterTriggered] = useState(false);

	let [filteredData, setFilteredData] = useState([]);
	let [userData, setUserData] = useState();
	let [checkValues, setcheckValues] = useState(0);
	const [apiValue, setApiValue] = useState("vehicles");
	const [searchQuery, setSearchQuery] = useState("");
	const [ObjectsearchQuery, setObjectSearchQuery] = useState("");
	const [ObjectUsersearchQuery, setObjectUserSearchQuery] = useState("");
	const [onlineVehicles, setOnlineVehicles] = useState(false);
	const [offlineVehicles, setOfflineVehicles] = useState(false);
	const [unknownVehicles, setUnkownVehicles] = useState(false);
	const [idleVehicles, setIdleVehicles] = useState(false);
	const [movingVehicles, setMovingVehicles] = useState(false);
	const [Sort, setSort] = useState({ type: "", value: null });
	const [limit, setLimit] = useState(10);
	const [totalPages, setTotalPages] = useState();
	const [loader, setLoader] = useState(false);
	const [vehicleArchived, setVehicleArchived] = useState("All vehicles");
	const handleFilter = () => setFilter(true);
	const [trackingType, setTrackingType] = useState("vehicle");
	const [trackingTypeIds, setTrackingTypeIds] = useState([]);
	const [login, setLogin] = useState(false);
	return (
		<>
			<filtrationcontext.Provider
				value={{
					checked,
					setChecked,
					filter,
					setFilter,
					isFilterTriggered,
					setIsFilterTriggered,
					handleFilter,
					checkValues,
					setcheckValues,
					apiValue,
					setApiValue,
					searchQuery,
					setSearchQuery,
					ObjectsearchQuery,
					setObjectSearchQuery,
					ObjectUsersearchQuery,
					setObjectUserSearchQuery,
					subchildCheck,
					setSubChildCheck,
					parentCheck,
					setParentCheck,
					childCheck,
					setChildCheck,
					filteredData,
					setFilteredData,
					userData,
					setUserData,
					limit,
					setLimit,
					totalPages,
					setTotalPages,

					onlineVehicles,
					setOnlineVehicles,
					offlineVehicles,
					setOfflineVehicles,
					unknownVehicles,
					setUnkownVehicles,
					idleVehicles,
					setIdleVehicles,
					movingVehicles,
					setMovingVehicles,
					Sort,
					setSort,
					loader,
					setLoader,
					vehicleArchived,
					setVehicleArchived,
					trackingType,
					setTrackingType,
					trackingTypeIds,
					setTrackingTypeIds,
					login,
					setLogin,
				}}
			>
				{children}
			</filtrationcontext.Provider>
		</>
	);
}
